import {useMutation, useQueryClient} from '@tanstack/react-query'

import {jobKeys} from 'src/jobs/query-keys'
import {projectKeys} from 'src/projects/query-keys'
import {createServiceSchedule} from 'src/service-schedules/api'
import {serviceScheduleKeys} from 'src/service-schedules/query-keys'
import type {CreateServiceScheduleInput} from 'src/service-schedules/schemas'
import {workKeys} from 'src/work/query-keys'

export function useCreateServiceVisits(projectId: string) {
    const queryClient = useQueryClient()

    return useMutation({
        mutationFn: (input: CreateServiceScheduleInput) => createServiceSchedule(input),
        onSuccess: (schedule) => {
            queryClient.setQueryData(serviceScheduleKeys.detail(schedule.id), schedule)
            void queryClient.invalidateQueries({queryKey: serviceScheduleKeys.list(projectId)})
            void queryClient.invalidateQueries({queryKey: projectKeys.detail(projectId)})
            void queryClient.invalidateQueries({queryKey: projectKeys.lists()})
            void queryClient.invalidateQueries({queryKey: jobKeys.all})
            void queryClient.invalidateQueries({queryKey: workKeys.all})
        },
    })
}
